"use client";
import type { IPartFilter, IPartSortByOption } from "@contentful-api/types/contentful";
import { createContext } from "react";

export interface StaticFiltersContextValue {
    // Static configuration
    listOfFilters: IPartFilter[];
    sortByOptionsList: IPartSortByOption[];
    isMenPage: boolean;

    // Static methods
    clearRefinements: () => void;

    // Size locale (could be moved to separate context)
    sizeLocale: string;
    setSizeLocale: (locale: string) => void;
}

export const FiltersContext = createContext<StaticFiltersContextValue>({
    listOfFilters: [],
    sortByOptionsList: [],
    isMenPage: false,
    clearRefinements: null,
    sizeLocale: "",
    setSizeLocale: null,
});
